/* unplugin-vue-components disabled */import { render } from "./positiongroup.vue?vue&type=template&id=73303975&scoped=true"
import script from "./positiongroup.vue?vue&type=script&lang=js"
export * from "./positiongroup.vue?vue&type=script&lang=js"

import "./positiongroup.vue?vue&type=style&index=0&id=73303975&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73303975"]])

export default __exports__